import React from 'react';
import { Modal } from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../elements/CustomButton/CustomButton.jsx';
import FormInputs from '../../components/FormInputs/FormInputs.jsx';
import { getTable } from '../Components/JQueryTable/JQueryTableLogic';
import AlertError from '../Components/AlertError.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper';

class UpdateConvocatoria extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      fields: {},
      fieldError: {},
      file: null,
      isEdit: this.props.number !== 0,
      total: null,
      alert: null,
    }
    this._uploadFile = this._uploadFile.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.getAnnouncement = this.getAnnouncement.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }
  componentWillMount() {
  }
  componentDidMount() {
    this.getAnnouncement(this.props.number);
  }
  getAnnouncement(number) {
    this.props.incubationService
      .getAnnouncement(number)
      .then(res => {
        const auxFields = {
          numero: res.announcement.numero,
          inicio: res.announcement.fechainicio,
          fin: res.announcement.fechafin,
        };
        this.setState({
          fields: auxFields,
          total: res.announcement.total,
        });
        //this.drawTabs(res.contacts);
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de la convocatoria, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }
  hideAlert() {
    this.setState({ alert: null });
  }
  onContinue() {
    this.hideAlert();
    this.uploadInput.click();
  }
  _uploadFile() {
    if (this.state.total > 0) {
      this.setState({
        alert: (
          <SweetAlert
            info
            style={{ display: "block", marginTop: "-100px" }}
            title=""
            onConfirm={() => this.onContinue()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Continuar"
            cancelBtnText="Cancelar"
            showCancel
          >
            ¿Desea agregar nuevos equipos?
            <div>
            <small>Esta acción agregará el total de registros del archivo a una convocatoria existente</small>
            </div>
          </SweetAlert>
        )
      });
    } else {
      this.uploadInput.click();
    }
  }
  handleFileChange(e) {
    e.preventDefault();
    this.setState({ file: this.uploadInput.files[0] });
  }

  refreshTables() {
    const tableConv = getTable("convocatoria");
    tableConv.clear();
    tableConv.ajax.reload();
    tableConv.draw();
    const tableIdea = getTable("idea");
    tableIdea.clear();
    tableIdea.ajax.reload();
    tableIdea.draw();
    const tablePreInc = getTable("preIncubationTab");
    tablePreInc.clear();
    tablePreInc.ajax.reload();
    tablePreInc.draw();
    const tableInc = getTable("incubationTab");
    tableInc.clear();
    tableInc.ajax.reload();
    tableInc.draw();
  }

  onSave(){
      this.props.incubationService
        .updateAnnouncement(
          this.state.fields.numero,
          this.state.fields.inicio,
          this.state.fields.fin,
          this.state.file,
        )
        .then(res => {
          this.props.jumpToConvocatoriaTab(); // Volver al tab de Convocatoria despues de crear una nueva en caso de estar en otra tab
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Convocatoria guardada satisfactoriamente!</div>), 10);
          this.props.closeModal();
          this.props.getConvocatorias();
          this.refreshTables();
        })
        .catch(err => {
          this.props.setError((<div>Ha ocurrido un error mientras se actualizaban los datos de la convocatoria, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });

  }
  render() {
    return(
      <span>
        {this.state.alert}
        <Modal show onHide={() => this.props.closeModal()} style={{ display: "block", marginTop: "200px" }}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>Agregar equipos a convocatoria N° {this.state.fields.numero} </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>

                  <FormInputs
                    ncols = {['col-md-12']}
                    properties = {[
                      {
                        label : 'Archivo',
                        type : 'text',
                        bsClass : "form-control",
                        value: this.state.file ? this.state.file.name : 'No se seleccionó ningún archivo..',
                        disabled : true,
                        name: 'archivo',
                        error: false,
                      }
                    ]}
                  />
                  <span style={{ float: 'left' }}>
                    <input accept=".csv" ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                  </span>
                  <span style={{ float: 'right' }}>
                    <Button onClick={this._uploadFile} bsStyle="primary" fill={true}>Agregar archivo</Button>
                    <Button disabled={!this.state.file} onClick={() => this.setState({ file: null })} bsStyle="danger" fill={true}>
                      <i className="fa fa-ban"></i>
                    </Button>
                  </span>
                </Modal.Body>
                <Modal.Footer>
                  <span>
                    <Button onClick={this.onSave} >Guardar</Button>
                  </span>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>
      </span>
    );
  }
}

export default UpdateConvocatoria;



// WEBPACK FOOTER //
// ./src/views/Incubation/UpdateConvocatoria.jsx